import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "parking",
  "use": "parking-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"parking\"><g fill=\"currentColor\" class=\"nc-icon-wrapper\"><rect x=\"5\" y=\"5\" width=\"54\" height=\"54\" rx=\"5\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"2\" /><path data-color=\"color-2\" d=\"M24,48V16h9.5a9.5,9.5,0,0,1,0,19H24\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"2\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol